// src/components/QRModal.js
import React, { useRef } from 'react';
import { QRCodeSVG } from 'qrcode.react';

export default function QRModal({ restaurant, onClose }) {
  const qrRef = useRef();

  const menuUrl = `${window.location.origin}/menu/${restaurant.slug}`;

  const handleDownload = () => {
    const svg = qrRef.current.querySelector('svg');
    const svgData = new XMLSerializer().serializeToString(svg);
    const canvas = document.createElement('canvas');
    const size = 512;
    canvas.width = size;
    canvas.height = size + 80;
    const ctx = canvas.getContext('2d');

    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    const img = new Image();
    const blob = new Blob([svgData], { type: 'image/svg+xml;charset=utf-8' });
    const url = URL.createObjectURL(blob);

    img.onload = () => {
      ctx.drawImage(img, 0, 0, size, size);

      ctx.fillStyle = '#000000';
      ctx.font = 'bold 28px -apple-system, sans-serif';
      ctx.textAlign = 'center';
      ctx.fillText(restaurant.name, size / 2, size + 40);

      ctx.font = '18px -apple-system, sans-serif';
      ctx.fillStyle = '#666666';
      ctx.fillText(menuUrl, size / 2, size + 68);

      URL.revokeObjectURL(url);
      const link = document.createElement('a');
      link.download = `qr-${restaurant.slug}.png`;
      link.href = canvas.toDataURL('image/png');
      link.click();
    };
    img.src = url;
  };

  const handlePrint = () => {
    const printWindow = window.open('', '_blank');
    const svg = qrRef.current.querySelector('svg');
    const svgData = new XMLSerializer().serializeToString(svg);
    const svgBase64 = btoa(unescape(encodeURIComponent(svgData)));

    // eslint-disable-next-line no-useless-escape
    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>QR — ${restaurant.name}</title>
          <style>
            body {
              margin: 0;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              min-height: 100vh;
              font-family: -apple-system, sans-serif;
              background: #fff;
            }
            .qr-wrap {
              text-align: center;
              padding: 40px;
              border: 2px solid #000;
              border-radius: 24px;
              max-width: 400px;
            }
            img { width: 300px; height: 300px; }
            h1 { margin: 20px 0 8px; font-size: 28px; }
            p  { margin: 0; color: #666; font-size: 14px; }
            .scan { margin-bottom: 16px; font-size: 16px; color: #444; }
          </style>
        </head>
        <body>
          <div class="qr-wrap">
            <p class="scan">Сканируйте для просмотра меню</p>
            <img src="data:image/svg+xml;base64,${svgBase64}" />
            <h1>${restaurant.name}</h1>
            <p>${menuUrl}</p>
          </div>
          <script>window.onload = () => { window.print(); window.close(); }</scr${''}ipt>
        </body>
      </html>
    `);
    printWindow.document.close();
  };

  return (
    <div style={s.overlay} onClick={onClose}>
      <div style={s.modal} onClick={(e) => e.stopPropagation()}>
        <div style={s.header}>
          <div style={s.title}>QR-код меню</div>
          <button style={s.closeBtn} onClick={onClose}>✕</button>
        </div>

        <div style={s.restName}>{restaurant.name}</div>

        <div style={s.qrWrap} ref={qrRef}>
          <QRCodeSVG
            value={menuUrl}
            size={220}
            bgColor="#ffffff"
            fgColor="#000000"
            level="H"
            includeMargin={true}
          />
        </div>

        <div style={s.urlBox}>
          <span style={s.urlText}>{menuUrl}</span>
          <button
            style={s.copyBtn}
            onClick={() => navigator.clipboard.writeText(menuUrl)}
          >
            Копировать
          </button>
        </div>

        <div style={s.actions}>
          <button style={s.btnDownload} onClick={handleDownload}>
            ⬇️ Скачать PNG
          </button>
          <button style={s.btnPrint} onClick={handlePrint}>
            🖨️ Распечатать
          </button>
        </div>
      </div>
    </div>
  );
}

const s = {
  overlay: {
    position: 'fixed',
    inset: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
    padding: '16px',
  },
  modal: {
    backgroundColor: '#fff',
    borderRadius: '24px',
    padding: '24px',
    width: '100%',
    maxWidth: '360px',
    boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '8px',
  },
  title: { fontSize: '18px', fontWeight: '700' },
  closeBtn: {
    background: 'none',
    border: 'none',
    fontSize: '20px',
    cursor: 'pointer',
    color: '#888',
    padding: '4px',
  },
  restName: { fontSize: '14px', color: '#888', marginBottom: '20px' },
  qrWrap: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '20px',
    padding: '16px',
    backgroundColor: '#f9f9f9',
    borderRadius: '16px',
  },
  urlBox: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    backgroundColor: '#f5f5f5',
    borderRadius: '12px',
    padding: '10px 14px',
    marginBottom: '16px',
  },
  urlText: { flex: 1, fontSize: '12px', color: '#555', wordBreak: 'break-all' },
  copyBtn: {
    fontSize: '12px',
    padding: '6px 12px',
    borderRadius: '8px',
    border: 'none',
    backgroundColor: '#000',
    color: '#fff',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
  },
  actions: { display: 'flex', gap: '8px' },
  btnDownload: {
    flex: 1,
    padding: '12px',
    borderRadius: '12px',
    border: 'none',
    backgroundColor: '#000',
    color: '#fff',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
  },
  btnPrint: {
    flex: 1,
    padding: '12px',
    borderRadius: '12px',
    border: 'none',
    backgroundColor: '#f0f0f0',
    color: '#000',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
  },
};
